import {hitGoogleTagManager} from "../../../tracking/google_tag_manager/hit_google_tag_manager";

export const hitGtmSurveyView = (eventCategory: string, customLabel?: string) => {
    const gtmData = {
        event: "survey_basic",
        event_action: "view",
        event_category: eventCategory,
        ...(customLabel ? {custom_label: customLabel} : {})
    };

    hitGoogleTagManager(gtmData);
};
import {hitGoogleTagManager} from "../../../tracking/google_tag_manager/hit_google_tag_manager";

export const hitGtmSurveyView = (eventCategory: string, customLabel?: string) => {
    const gtmData = {
        event: "survey_basic",
        event_action: "view",
        event_category: eventCategory,
        ...(customLabel ? {custom_label: customLabel} : {})
    };

    hitGoogleTagManager(gtmData);
};
